var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wind-drag-item",attrs:{"draggable":"true","data-drag-item-key":_vm.dragKey},on:{"dragend":_vm.onDragEnd}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }